import { ArrowLeft } from '@cat-home-experts/mortar-iconography-web/ArrowLeft';
import { Cross } from '@cat-home-experts/mortar-iconography-web/Cross';

type Props = {
  onBack?: () => void;
  currentStep?: number;
  maxSteps?: number;
  onCancel?: () => void;
  disableDismiss?: boolean;
};

const Header = ({
  onBack,
  currentStep,
  maxSteps = 1,
  onCancel,
  disableDismiss,
}: Props) => {
  const handleBack = (event: React.MouseEvent) => {
    event.preventDefault();
    onBack?.();
  };

  const handleCancel = (event: React.MouseEvent) => {
    event.preventDefault();
    onCancel?.();
  };

  const progress = maxSteps && currentStep ? (currentStep / maxSteps) * 100 : 0;

  return (
    <div className="flex items-center justify-end">
      {typeof onBack === 'function' && (
        <button
          className="mr-2 flex size-8 cursor-pointer items-center justify-center rounded-[32px] bg-[#EAEAEA4D]"
          onClick={handleBack}
          aria-label="Back"
        >
          <ArrowLeft size={16} color="" />
        </button>
      )}
      {currentStep && (
        <div
          className="h-2 grow rounded-full bg-accent-5"
          role="progressbar"
          aria-valuenow={progress}
          aria-valuemax={100}
        >
          <div
            className="h-full rounded-full bg-secondary-50"
            style={{ width: `${progress}%` }}
          />
        </div>
      )}
      {!disableDismiss && (
        <button
          className="ml-2 flex size-8 cursor-pointer items-center justify-center rounded-[32px] bg-[#EAEAEA4D]"
          onClick={handleCancel}
          aria-label="Cancel"
        >
          <Cross size={14} color="" />
        </button>
      )}
    </div>
  );
};

export default Header;
